import { Box, Button, Text } from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import Tip, { TipProps } from "../../tips/Tip"

function HomeWelcomeMemberBlankSlateTip(props: Partial<TipProps>) {
  const { me } = usePathwrightContext()

  return (
    <Tip
      tip={{
        id: "home-welcome-member-blank-slate",
        title: `Welcome, ${me.first_name}!`,
        content: (
          <Box>
            <Text color="inherit" mt={0}>
              Your Home screen is where you can keep track of all your learning
              Paths.
            </Text>
            <Text color="inherit">
              To get started,{" "}
              <Button
                as={ReactRouterLink}
                variant="link"
                bg="transparent"
                color="inherit"
                cursor="pointer"
                _hover={{
                  color: "inherit"
                }}
                to="/library/"
              >
                add a Path
              </Button>
              .
            </Text>
          </Box>
        )
      }}
      icon="lightbulb-on"
      layout="dismissable"
      colorScheme="dark"
      {...props}
    />
  )
}

export default HomeWelcomeMemberBlankSlateTip
